<template>
  <nav class="ui-navi" id="js-ui-navi">
    <ul>
      <li
        v-for="(item, key) in menu"
        :key="key"
        v-show="(item.for_in && $store.state.user_data.is_motom_internal_user) || !item.for_in ? true : false"
        :class="[
          'menu-item-' + strToSlug(item.text),
          item.show === false && 'menu-item-hide',
          { 'show-unread': item.meta === 'chats' && $store.state.unread_message_count },
          { 'has-dropdown': item.dropdown },
          { 'dropdown-open': open_dropdown_key === key },
        ]"
      >
        <!-- Dropdown trigger -->
        <div
          v-if="item.dropdown"
          class="link dropdown-trigger"
          :class="{ 'router-link-active': isDropdownActive(item) }"
          @click.stop="toggleDropdown(key, $event)"
        >
          <span v-html="item.text"></span>
          <i class="dropdown-arrow" />
        </div>
        <!-- Normal router-link -->
        <router-link
          v-else-if="type === 0"
          :to="item.to"
          :class="{ 'router-link-active': $route.meta.menu_sub && item.meta && $route.meta.menu_sub === item.meta }"
        >
          <span v-html="item.text"></span>
        </router-link>
        <div
          v-else
          class="link"
          :class="{ 'link-selected': selected_index === key, 'menu-item-hide': item.show === false }"
          @click="selectIndex(key)"
        >
          <span v-html="item.text"></span>
        </div>
      </li>
    </ul>
  </nav>

  <Teleport to="body">
    <ul
      v-if="open_dropdown_key !== null && menu[open_dropdown_key]?.dropdown"
      class="ui-navi-sub-menu"
      :style="{ top: dropdown_position.top + 'px', left: dropdown_position.left + 'px' }"
      @click.stop
    >
      <li
        v-for="(sub, sk) in menu[open_dropdown_key].dropdown"
        :key="sk"
        v-show="(sub.for_in && $store.state.user_data.is_motom_internal_user) || !sub.for_in"
      >
        <router-link :to="sub.to" @click="open_dropdown_key = null">{{ sub.text }}</router-link>
      </li>
    </ul>
  </Teleport>
</template>

<script>
export default {
  name: 'Navi',
  emits: ['selected-tab'],
  props: {
    type: {
      //0: link; 1: tab
      default: 0,
      type: Number,
    },
    menu: {
      default: [],
      type: Array,
    },
    is_left: {
      default: false,
      type: Boolean,
    },
    type_one_index: {
      default: 0,
      type: Number,
    },
  },

  data() {
    return {
      selected_index: 0,
      open_dropdown_key: null,
      dropdown_position: { top: 0, left: 0 },
    };
  },

  methods: {
    selectIndex(index) {
      this.selected_index = index;
      this.$emit('selected-tab', index);
    },

    strToSlug(str) {
      str = str.replace(/[^\w\s]/g, '');
      return str.replace(/\s+/g, '-').toLowerCase();
    },

    toggleDropdown(key, event) {
      if (this.open_dropdown_key === key) {
        this.open_dropdown_key = null;
        return;
      }
      const rect = event.currentTarget.getBoundingClientRect();
      this.dropdown_position = { top: rect.bottom + 2, left: rect.left };
      this.open_dropdown_key = key;
    },

    isDropdownActive(item) {
      if (!item.dropdown) return false;
      return item.dropdown.some(sub => this.$route.path === sub.to);
    },

    closeDropdown() {
      this.open_dropdown_key = null;
    },
  },

  mounted() {
    if (this.type === 1) {
      this.selected_index = 0;
    }

    if (this.type_one_index) {
      this.selected_index = this.type_one_index;
    }

    document.addEventListener('click', this.closeDropdown);
  },

  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdown);
  },
};
</script>
<style lang="scss">
.ui-navi {
  color: var(--black-50);
  flex: 1;

  ul {
    display: flex;
  }

  ul li a,
  .link {
    color: var(--black-40);
    display: flex;
    align-items: center;
    height: 40px;
    font: var(--font-med-14);
    margin: 0 8px;
    position: relative;
    cursor: pointer;

    svg {
      height: 20px;
      width: 20px;
      margin-right: 8px;
    }

    .svg-icon--analytics,
    .svg-icon--help {
      height: 18px;
      width: 18px;
      position: relative;
      left: 1px;

      & + span {
        position: relative;
        left: 2px;
      }
    }

    .svg-icon--setting {
      height: 26px;
      width: 26px;

      & + span {
        position: relative;
        left: -3px;
      }
    }

    &:hover {
      color: var(--black-75);
    }

    &.router-link-active,
    &.router-link-exact-active,
    &.link-selected {
      background: rgba(255, 255, 255, 0.15);
      // border: 1px solid rgba(255, 255, 255, 0.05);
      color: var(--black-75);
      // border-bottom: 3px solid #F15A29;

      &::before {
        height: 3px;
        position: absolute;
        bottom: 0;
        content: '';
        background-color: var(--dark-blue);
        width: 100%;
        left: 0;
        border-radius: 2px;
      }
    }
  }

  ul li.show-unread a {
    position: relative;

    &::after {
      height: 8px;
      width: 8px;
      background-color: var(--red);
      border-radius: 50%;
      content: '';
      position: absolute;
      right: -8px;
      top: 8px;
    }
  }

  ul li:first-child a,
  ul li:first-child .link {
    margin-left: 0;
  }

  .menu-item-hide {
    display: none;
  }

  li.has-dropdown {
    position: relative;

    .dropdown-trigger {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      user-select: none;
    }

    .dropdown-arrow {
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 5px solid currentColor;
      transition: transform 0.2s;
    }

    &.dropdown-open .dropdown-arrow {
      transform: rotate(180deg);
    }

  }
}

.ui-navi-sub-menu {
  position: fixed;
  background: white;
  border: 1px solid var(--black-10);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  min-width: 120px;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;

  li {
    list-style: none;
  }

  a {
    display: block;
    padding: 8px 16px;
    font: var(--font-med-14);
    color: var(--black-75);
    white-space: nowrap;
    height: auto;
    margin: 0;
    text-decoration: none;

    &:hover {
      background: var(--bg-03);
      color: var(--black-90);
    }

    &.router-link-active,
    &.router-link-exact-active {
      color: var(--dark-blue);
      background: var(--bg-03);
      
    }
  }
}
</style>
